export default __webpack_public_path__ + "static/media/icon-Hub-Toolbox.ee74d353.svg";